<template>
    <v-card min-width="21vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 pt-7">
            <v-form v-model="valid">
                <p v-if="brokerAccount.verified">{{ $t('verifiedMessage') }} <v-icon class="ml-2" color="blue" small>fa-check-circle</v-icon></p>
                <v-autocomplete :label="$t('broker')" :items="brokers" :disabled="true" item-text="name" item-value="id" :rules="brokerRule" :hint="$t('brokerHint')"
                                persistent-hint v-model="brokerChoosed" outlined/>
                <v-text-field :label="$t('identifier')" v-model="accountId" :disabled="brokerAccount.verified" outlined/>
                <v-select :label="$t('type')" :items="['Live', 'Demo']" :rules="accountTypeRule" v-model="typeChoosed" :disabled="brokerAccount.verified" outlined/>
                <v-select :label="$t('currency')" :items="currencies" :rules="currencyRule" v-model="currencyChoosed" outlined/>
                <v-btn @click="editBrokerAccount">{{ $t('btnSave') }}</v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../../repositories/brokerAccount';
    import { mapMutations } from 'vuex';
    export default {
        name: "EditBrokerAccount",
        props: {
            brokerAccount: Object,
        },
        mounted() {
            this.init();
        },
        data() {
            return {
                // Data
                accountId: '',
                typeChoosed: '',
                currencyChoosed: '',
                brokerChoosed: '',
                brokers: [],
                currencies: [
                    'USD',
                    'AUD',
                    'EUR',
                    'GBP',
                    'JPY',
                    'BRL',
                    'MXN',
                    'COP',
                    'CLP',
                ],

                // Rules
                valid: false,
                brokerRule: [
                    b => !!b || 'Broker is required',
                ],
                accountTypeRule: [
                    a => !!a || 'Type is required',
                ],
                currencyRule: [
                    c => !!c || 'Currency is required',
                ],
            };
        },
        methods: {
            init() {
                this.brokers.push(this.brokerAccount.broker);
                this.brokerChoosed = this.brokerAccount.broker.id;
                this.accountId = this.brokerAccount.identifier;
                this.typeChoosed = (this.brokerAccount.type.startsWith('D'))? 'Demo' : 'Live';
                this.currencyChoosed = this.brokerAccount.currency;
            },
            ...mapMutations(['setBrokerAccounts']),
            editBrokerAccount() {
                if(this.valid){
                    let brokerAccount = {
                        id: this.brokerAccount.id,
                        broker: {
                            id: this.brokerChoosed
                        },
                        user: {
                            id: this.$store.state.user.id
                        },
                        type: this.typeChoosed.toUpperCase(),
                        identifier: this.accountId,
                        currency: this.currencyChoosed,
                        verified: this.brokerAccount.verified,
                        automated: this.brokerAccount.automated,
                    };

                    Repository.updateBrokerAccount(brokerAccount).then((response) => {
                        if(response.status < 400) {
                            Repository.allBrokerAccountsOfUser().then((responseRetrieving) => {
                                this.setBrokerAccounts(responseRetrieving.data);
                            });
                        }
                    });
                    this.$emit('closeWindow');
                }
                else
                    alert('Broker account can\'t be saved.\nThere are one or more mandatory fields that are not filled.');
            },
            closeWindow() {
                this.$emit('closeWindow');
            }
        }
    }
</script>

<i18n>
{
  "en": {
    "title": "Edit Broker Account",
    "verifiedMessage": "This is a verified account",
    "broker": "Broker",
    "brokerHint": "Broker Name",
    "identifier": "Account ID",
    "type": "Account Type",
    "currency": "Account Currency",
    "btnSave": "Save Account"
  },
  "es": {
    "title": "Agregar Cuenta de Broker",
    "verifiedMessage": "Esta es una cuenta verificada",
    "broker": "Broker",
    "brokerHint": "Nombre del Broker",
    "identifier": "ID de Cuenta",
    "type": "Tipo de Cuenta",
    "currency": "Moneda de Cuenta",
    "btnSave": "Guardar Cuenta"
  }
}
</i18n>

<style scoped>

</style>
